(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dna-about-fingerprint"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initHelix() {
    var section = document.querySelector('.dna-fingerprint');
    if (!section || section.dataset.dnaFpInit === '1') return;
    section.dataset.dnaFpInit = '1';

    var orbitTexts = section.querySelectorAll('.dna-fingerprint__orbit-text');

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      section.classList.add('dna-fingerprint--draw');
      orbitTexts.forEach(function (t) { t.classList.add('dna-orbit--visible'); });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting) {
          section.classList.add('dna-fingerprint--draw');
          setTimeout(function () {
            orbitTexts.forEach(function (t) { t.classList.add('dna-orbit--visible'); });
          }, 900);
          observer.disconnect();
          break;
        }
      }
    }, { threshold: 0.15, rootMargin: '0px 0px -10% 0px' });
    observer.observe(section);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHelix);
  } else {
    initHelix();
  }
  document.addEventListener('shopify:section:load', initHelix);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
